<template>
<div class="gatewrayWrap">
  <div class="gotoGate">
    <div v-if="pageType == pageTypeList[0]">
      <button class="active">공정도</button>
      <button @click="gotoSwitch">실험입력</button>
    </div>
    <div v-if="pageType == pageTypeList[1]">
      <button class="active">공정도</button>
    </div>
  </div>
<!--  <div class="aside">
    <div class="overflow">
      <h3>공정도 생성하기</h3>
      <p class="empty" @click="templateSelect">새 공정도</p>
        <h3>공정도 템플릿으로 시작하기</h3>
        <Templates :list='defaultTemplates' :listType="`template`" @click="templateSelect"/>
    </div>
  </div>-->
  <div class="templateSearch">
    <div class="slctWrap">
      <ProcessFieldSelector @change="(value)=>{selectSearchField=value.value;searchConditionChangeFlag=true}" />
      <ProcessTargetSelector @change="(value)=>{selectSearchTarget=value.value;searchConditionChangeFlag=true}" />
    </div>
      <div class="textInput">
        <input type="text" ref="searchInputTag" @keydown="inputEnter" v-model="searchInputData" placeholder="검색어를 입력하세요." />
        <button v-if="searchInputData" class="clear" @click="clearTextInput">검색어 삭제</button>
<!--        <button class="searchButton" @click="search">search</button>-->
        <button class="searchButton" @click="getMyProcess();searchConditionChangeFlag=true">search</button>
      </div>
      <UserInfomation :userName="userName" :type="'gateway'"/>
    
  </div>
  <div class="templateResult">
    <h3 v-if="pageType == pageTypeList[0]">{{searchType | checkTitle}} <button class="btn_create md10" @click="templateSelect">공정도 생성하기</button></h3>
    <Templates :list='searchTemplates' @click="loadProcess"/>
    <Pagination ref="resultsCount" :pageCnt="pageNo" :pageTotalCnt="totalPage" :size="9" @click="selectPage"></Pagination>
  </div>
  <MakeProcess :active="titleModal" @confirm="(info)=>confirmMakeProcess(info)"></MakeProcess>
  <Loading :visible="loading" />
</div>
</template> 

<script>
import { createNamespacedHelpers } from 'vuex';
import CommNew from "@processEditor/CommNew";
import Templates from '../common/template/templates.vue'
import ProcessFieldSelector from '../common/selects/FieldSelector.vue'
import ProcessTargetSelector from '../common/selects/TargetSelector.vue'
import Loading from '../common/loading.vue'
import UserInfomation from '../common/user/userInfo.vue'
import { v4 } from "uuid";

import Pagination from '@common/Pagination.vue'
import MakeProcess from '@/components/modal/MakeProcess';

export default {
  mixins: [CommNew],
  components: {
    Templates, 
    ProcessFieldSelector, 
    ProcessTargetSelector, 
    UserInfomation, 
    Loading, 
    Pagination, 
    MakeProcess,
  },
  data(){
    return {
      userName: '',
      searchInputData: '',
      selectSearchTarget: 'name',
      selectSearchField:'',
      loading: false,
      defaultTemplates: [],
      myProcess: [],
      searchTemplates: [],
      searchType: 'myprocess',
      // searchType: 'another',
      searchTimer: null,
      pageNo : 1 , 
      totalPage : 0 , 
      titleModal: false,
      searchConditionChangeFlag : false,
      pageTypeList: ['experiment', 'visualization'],
      pageType: '',
    }
  },
  filters: {
    checkTitle(type) {
      let title = ''
      switch(type) {
        case 'myprocess' :
        title = '공정도 목록'
          break;
        case 'another' :
        title = '다른 사람 작성 목록'
          break;
        case 'search' :
        title = '검색결과'
          break
      }
      return title
    }
  },
  watch: {
    USER_INFO(value) {
      this.userName = value.loginId
    },
    async $route(value) {
      await this.setPageType(value.path);
    }
  },
  async mounted() {
    try {
      this.loading = true;
      await this.setPageType(this.$route.path);
      const userData = await this.$wApi.user.me();
      this.userName = userData.name
      await this.getDefaultTemplate()
      await this.getMyProcess()
    }catch(error) {
      this.$router.push({
        path:'/'
      })
    }
    this.loading = false
  },
  methods: {
    gotoSwitch(){
      this.$router.push({
        path : '/experiment/gate' ,
        query : {
          editorType: 'gate'
        } ,
      }) ;
    },    
    checkKeyTimer() {
      clearTimeout(this.searchTimer)
      this.searchTimer = setTimeout( ()=> {
        this.search()
      }, 500 )
    },
    inputEnter(event) {
      if(event.code === 'Enter' || event.keyCode === 13) {
        this.search();
      }
      //  else {
      //   this.checkKeyTimer()
      // }
    },
    clearTextInput(){
      this.searchInputData = ''
      this.searchTemplates = this.myProcess
    },

    async getDefaultTemplate() {
      // 썸네일 테이블 추가 예정
      try {
        const response = await this.$wApi.process.search({
          pageNo: 1,
          perPage: 12,
          isThumbnail: 1,
          isProtocol: 0 , // 
          isMyData : 0,  // 이거는 내꺼만!!! 
          processType:'TEMPLATE',
          // query:null,
        }) ; 
        let {content} = response

        for ( const {thumbnail, processName, fieldName, processId} of content) {

          this.defaultTemplates.push({
            src: thumbnail ? `data:image/jpeg;base64,${thumbnail}` : '',
            title: processName,
            field: fieldName,
            processId : processId,
          }) ; 
        }
        this.defaultTemplates.sort((a, b) => {
            const titleA = a.title.toUpperCase();
            const titleB = b.title.toUpperCase();

            if (titleA < titleB) {
                return -1;
            }
            if (titleA > titleB) {
                return 1;
            }

            return 0;
        });
        // console.log( "defaultTemplates", this.defaultTemplates )
      } catch(error) {

      }
    },

    async selectPage( idx ) {
      this.pageNo = idx;
      await this.getMyProcess() ; 
    } , 
    async search() {
      this.loading = true
      this.$refs.searchInputTag.blur()
      // if(!this.searchInputData || this.searchInputData === '') {
      //   this.searchTemplates = this.myProcess
      //   this.searchType = 'myprocess'
      //   this.loading = false
      //   return
      // }

      
      // console.log( this.searchInputData ) ;

      if(this.searchConditionChangeFlag === true){
        this.pageNo = 1;
        this.searchConditionChangeFlag = false;
      }
      let data = {};
      if(this.pageType == this.pageTypeList[0]) {
        data = {
          query: this.searchInputData,
          targetField: this.selectSearchTarget,
          fieldId: this.selectSearchField,
          // processType:'ONLY_PROTOCOL',
          processType: 'NORMAL',
          pageNo: 1,
          perPage: 12,
          isThumbnail: 1,
          isProtocol: 0,
          isMyData: 1
        };
        // console.log({ data })
      }else if(this.pageType == this.pageTypeList[1]){
        data = {
          query: this.searchInputData,
          targetField: this.selectSearchTarget,
          fieldId: this.selectSearchField,
          // processType:'ONLY_PROTOCOL',
          processType: 'NORMAL',
          pageNo: 1,
          perPage: 12,
          isThumbnail: 1,
          isProtocol: 0,
          isMyData: 0,
          isReleaseData: 1,
        };
      }

      const response = await this.$wApi.process.search( data ) ;
      this.totalPage = response.totalPages ;
      const content = response.content
      this.searchTemplates = [];
      for ( const {thumbnail, processName, fieldName, processId, companyCode, publicActive, updatedDate} of content) {
          this.searchTemplates.push({
            src: thumbnail ? `data:image/jpeg;base64,${thumbnail}` : '',
            title: processName,
            field: fieldName,
            processId : processId,
            companyCode : companyCode,
            publicActive : publicActive,
            updateDate : updatedDate,
            mode : "process"
          })
        }
      /*this.searchType = 'search'*/
      this.loading = false
    },
    async makeEmpty(info) {
      try {
        const response = await this.$wApi.process.create({
          name: info.name,
          nameEng : info.nameEng,
          fieldId: info.fieldId,
          processType: 'NORMAL',
          active: true,
          // 과학기술분류 
          knsccId: info.requestKnscc.knsccId,
          // 과학기술표준분류코드 
          knsccCode: info.requestKnscc.knsccCode,
          // 과학기술표준분류명 
          knsccCodeName: info.requestKnscc.knsccCodeName,
          // 대분류코드 
          categoryLargeCode: info.requestField.categoryLargeCode,
          // 대분류명 
          categoryLargeCodeName: info.requestField.categoryLargeCodeName,
          // 중분류코드 
          categoryMiddleCode: info.requestField.categoryMiddleCode,
          // 중분류명 
          categoryMiddleCodeName: info.requestField.categoryMiddleCodeName,
          // 소분류코드(공정식별번호) 
          categorySmallCode: info.requestField.categorySmallCode,
          // 소분류코드명 
          categorySmallCodeName: info.requestField.categorySmallCodeName,
          // 소소분류코드(하부공정식별번호) 
          categoryMicroCode: info.requestField.categoryMicroCode,
          // 소소분류코드명 
          categoryMicroCodeName: info.requestField.categoryMicroCodeName,
        }, null, {
          useError: true
        })
        if(response && response.processId) {
          /** 로그 등록 */
          await this.$wApi.trace.log({
            type : 'PD', //PD 공정도, PR 프로토콜
            code : 'N', //N 생성 M 수정 S 검색 R 조회
            subCode : '01',
            keyword : '',
            result : 0,
            ptlId : response.processId
          });
          /** 로그 등록 */            

          this.$router.push({
            path:'/process/editor',
            query: {
              processId: response.processId,
              editorType: 'process',
              menuType : "manager",
            }
          })
        }
      } catch (error) {

      }
    },
    async loadTemplate(clickItemInfo) {
      //현재 동작 방식 및 API가 재 수정 되어야 함으로 예상 동작으로 작업
      if(!clickItemInfo) return
      try {
        // 사용할 템플릿의 node 정보 호출
        const templateDataResponse = await this.$wApi.process.detail(null, clickItemInfo.processId)
        const thumbnail = await this.$wApi.process.thumbnail.get(null, clickItemInfo.processId)
        const templateData = JSON.parse(templateDataResponse.json)
        // 템플릿 정보 호출 후 프로세스 생성
        const date = new Date()
        const newKeys = {}
        const newProcessResponse = await this.$wApi.process.create({
          // name: `공정도명 ${date.getFullYear()}.${date.getMonth()}.${date.getDate()} ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`,
          name: clickItemInfo.name,
          nameEng : clickItemInfo.nameEng,
          fieldId: clickItemInfo.fieldId,
          processType: 'NORMAL',
          active: true,
          // 과학기술분류 
          knsccId: clickItemInfo.requestKnscc.knsccId,
          // 과학기술표준분류코드 
          knsccCode: clickItemInfo.requestKnscc.knsccCode,
          // 과학기술표준분류명 
          knsccCodeName: clickItemInfo.requestKnscc.knsccCodeName,
          // 대분류코드 
          categoryLargeCode: clickItemInfo.requestField.categoryLargeCode,
          // 대분류명 
          categoryLargeCodeName: clickItemInfo.requestField.categoryLargeCodeName,
          // 중분류코드 
          categoryMiddleCode: clickItemInfo.requestField.categoryMiddleCode,
          // 중분류명 
          categoryMiddleCodeName: clickItemInfo.requestField.categoryMiddleCodeName,
          // 소분류코드(공정식별번호) 
          categorySmallCode: clickItemInfo.requestField.categorySmallCode,
          // 소분류코드명 
          categorySmallCodeName: clickItemInfo.requestField.categorySmallCodeName,
          // 소소분류코드(하부공정식별번호) 
          categoryMicroCode: clickItemInfo.requestField.categoryMicroCode,
          // 소소분류코드명 
          categoryMicroCodeName: clickItemInfo.requestField.categoryMicroCodeName,
        }, null, {
          useError: true
        })

        for(const node of templateData.nodes){
          const newKey = v4()
          newKeys[node.key] = newKey
          node.key = newKey
          delete node.__gohashid
        }
        for(const link of templateData.links){
          link.from = newKeys[link.from]
          link.to = newKeys[link.to]
        }

        /** 로그 등록 */
        await this.$wApi.trace.log({
          type : 'PD', //PD 공정도, PR 프로토콜
          code : 'N', //N 생성 M 수정 S 검색 R 조회
          subCode : '01',
          keyword : '',
          result : 0,
          ptlId : newProcessResponse.processId
        });
        /** 로그 등록 */          

        // 새로 생성된 프로세스에 template 정보 입력 후 업로드
        await this.$wApi.process.put( {json:templateData}, newProcessResponse.processId);

        await this.$wApi.process.thumbnail.put({
          processId: newProcessResponse.processId,
          thumbnail: thumbnail.thumbnail,
        }, newProcessResponse.processId)
        // 업로드 완료 후 프로세스 에디터 페이지 호출

        // await this.$wApi.process.modify({active:true}, newProcessResponse.processId);

        this.$router.push({
          path:'/process/editor',
          query: {
            processId: newProcessResponse.processId,
            editorType: 'process',
            menuType : "manager",
          }
        })
      } catch (error) {
        
      }
    },
    async getMyProcess() {
      // [공정도 게이트웨이], [프로토콜 게이트웨이] 나의 최근 작성목록 스크롤 시 페이징 기능 추가.
      // - 공정도 목록 스크롤 시 리스트 12개씩 페이징 추가 노출.

      // console.log({ pageNo : this.pageNo }) ;

      this.loading = true
      this.$refs.searchInputTag.blur()

      if(this.searchConditionChangeFlag === true){
        this.pageNo = 1;
        this.searchConditionChangeFlag = false;
      }

      let contents = null;
      if( this.searchType === 'myprocess'){
        if(this.pageType == this.pageTypeList[0]) {
          /*        let response = await this.$wApi.process.search({
          pageNo: this.pageNo,
          perPage: 12, 
          isThumbnail: 1, 
          isProtocol: 1, 
          isMyData: 1, 
          processType:'NORMAL',
        });*/

          let response = await this.$wApi.process.search({
            query: this.searchInputData,
            targetField: this.selectSearchTarget,
            fieldId: this.selectSearchField,
            pageNo: this.pageNo,
            perPage: 12,
            isThumbnail: 1,
            isProtocol: 1,
            isMyData: 1,
            processType: 'NORMAL',
          });

          // console.log({ response }) ;
          this.totalPage = response.totalPages;
          contents = response.content
        }else if(this.pageType == this.pageTypeList[1]){ // 시각화
          let response = await this.$wApi.process.search({
            query: this.searchInputData,
            targetField: this.selectSearchTarget,
            fieldId: this.selectSearchField,
            pageNo: this.pageNo,
            perPage: 12,
            isThumbnail: 1,
            isProtocol: 1,
            isMyData: 0,
            processType: 'NORMAL',
            isReleaseData: 1,
          });
          this.totalPage = response.totalPages;
          contents = response.content
        }
      }else if( this.searchType === 'another' ){
        let response = await this.$wApi.process.search({
          pageNo: this.pageNo,
          perPage: 12, 
          isThumbnail: 1, 
          isProtocol: 1, 
          processType:'NORMAL',
        });

        // console.log({ response }) ;
        this.totalPage = response.totalPages ;
        contents = response.content
      }

      // console.log( {contents} )
      // 작성자의 작업목록이 없을 경우 기본 검색 리스트 호출

      // console.log({
      //   searchInputData : this.searchInputData , 
      //   selectSearchTarget : this.selectSearchTarget , 
      //   selectSearchField : this.selectSearchField , 
      // }) ; 


      // console.log( '???' , { response }) ; 

      this.myProcess = [] ; 
      this.searchTemplates = [] ;
      setTimeout(async _=>{
        for await ( const {thumbnail, process} of this.processThumbnail(contents)) {
          // console.log( thumbnail , process ) ; 
          this.myProcess.push({
            src: thumbnail ? `data:image/jpeg;base64,${thumbnail.thumbnail}` : '',
            title: process.processName,
            field: process.fieldName,
            processId : process.processId,
            companyCode : process.companyCode,
            publicActive : process.publicActive,
            updateDate : process.updatedDate,
            mode : "process"
          })
        }
        
        this.searchTemplates = this.myProcess
        // console.log( 'this.myProcess : ' , this.myProcess ) ; 
      }) ;
      this.loading = false
    },
    async *processThumbnail(processList) {
      try {
        for(let process of processList) {
          let thumbnail = await this.$wApi.process.thumbnail.get(null, process.processId)
          // console.log({ thumbnail , process })
          yield {thumbnail, process}
        }
      }catch (error) {
        return error
      }
    },
    async loadProcess(e) {      
      this.updateState({ templateInitBln : true }) ; 
      if(this.pageType == this.pageTypeList[0]) {
        this.$router.push({
          path: '/process/editor',
          query: {
            processId: e.processId,
            editorType: 'process',
            menuType: "manager",
          }
        })
      }else if(this.pageType == this.pageTypeList[1]){
        this.$router.push({
          path: '/visualization/editor',
          query: {
            processId: e.processId,
            editorType: 'process',
            menuType: "manager",
          }
        })
      }
    },
    async templateSelect(clickItemInfo) {
      this.titleModal = true;
      const loadTemplate = async (info) => {
        this.loading = true;
        clickItemInfo.name = info.kr;
        clickItemInfo.nameEng = info.en;
        clickItemInfo.fieldId = info.field[info.field.length - 1];
        clickItemInfo.requestField = info.requestField;
        clickItemInfo.requestKnscc = info.requestKnscc;
        await this.loadTemplate(clickItemInfo);
        this.loading = false;
      }
      const emptyTemplate = async (info) => {
        this.loading = true;
        await this.makeEmpty({
          name: info.kr,
          nameEng: info.en,
          fieldId: info.field.pop(),
          requestField: info.requestField,
          requestKnscc: info.requestKnscc,
        });
        this.loading = false;
      }

      if(!clickItemInfo || !clickItemInfo.processId) {
        this.confirmMakeProcess = emptyTemplate;
      }else {
        this.confirmMakeProcess = loadTemplate;
      }
    },
    confirmMakeProcess(){},
    async setPageType(path) {
      for (const checkPageType of this.pageTypeList){
        if(path.includes(checkPageType)){
          this.pageType = checkPageType;
        }
      }
      if(this.pageType == ''){
        this.pageType = this.pageTypeList[0];  
      }
    },
  }
}
</script>

<style lang="scss">
@import '@/style/gateway_wrap.scss'; 
@import '@/style/gateway_template_search.scss'; 
@import '@/style/gateway_template_result.scss'; 
</style>
   